/**************************************************
 * Nombre:       Casilla_Funcion
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {TableCell} from "@mui/material";
import {COLORTEXTO} from "../../../Constantes";

const Casilla_Funcion = ({dato, dir, funcion = null}) => {


    const transformar = (e) => {


        if (funcion) {

            return funcion(e);

        } else {
            return 0
        }
    }


    return (
        <TableCell key={dato} variant={'body'} align={dir} sx={{color: COLORTEXTO, fontSize: 14, fontWeight: 500}}>
            {transformar(dato)}
        </TableCell>

    )

}
export default Casilla_Funcion